module.exports = __webpack_public_path__ + "static/media/gradually_launch_en.8bc26ec3.png";